import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import { NavLink, withRouter } from "react-router-dom";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import { HealthAndSenitationProtocol } from "./InsideComponent/HealthAndSenitationProtocol";
import { HealthAndSenitationOthers } from "./InsideComponent/HealthAndSenitationOthers";
import { HealthAndSenitationOthersTwo } from "./InsideComponent/HealthAndSenitationOthersTwo";
import { HealthAndSenitationOthersThree } from "./InsideComponent/HealthAndSenitationOthersThree";
import { HealthAndSenitationOthersFour } from "./InsideComponent/HealthAndSenitationOthersFour";
import { HealthAndSenitationOthersFive } from "./InsideComponent/HealthAndSenitationOthersFive";
import isEmpty from "../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { HealthAndSenitationHomeScreen } from "./HealthAndSenitationHomeScreen";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export class HealthAndSenitationOnboardingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      loader: false,
      hasSetMapProps: false,
      selectedTab: 2,
      healthAndSanitizeSwitchValue: false,
      healthAndSanitizeEntryPointCheck: true,
      healthAndSanitizeFacilityCheck: true,
      healthAndSanitizeServicesCheck: true,
      healthAndSanitizeEmployeesCheck: true,
      healthAndSanitizePracticesCheck: true,
      healthAndSanitizeProtocolCheck: true,
      selectedPage: 1,
      discription: "",
      healthandsanitization_entrypoint: [],
      healthandsanitization_facility: [],
      healthandsanitization_employees: [],
      healthandsanitization_food_handling: [],
      healthandsanitization_health_safety: [],
      // DATA
      selected_health_and_sanitization_entrypoint: [],
      selected_health_and_sanitization_facility: [],
      selected_health_and_sanitization_employees: [],
      selected_health_and_sanitization_food_handling: [],
      selected_health_and_sanitization_health_safety: [],
      primary_health_and_sanitization_entrypoint: {},
      primary_health_and_sanitization_facility: {},
      primary_health_and_sanitization_employees: {},
      primary_health_and_sanitization_food_handling: {},
      primary_health_and_sanitization_health_safety: {},
      errors: [],
      formShow: false,
    };
    // this.handleHealthAndSanitizeSwitchValue = this.handleHealthAndSanitizeSwitchValue.bind(
    //   this
    // );
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.health_entry_point) &&
      !isEmpty(nextProps.health_inside_facility) &&
      !isEmpty(nextProps.health_employees) &&
      !isEmpty(nextProps.health_handling) &&
      !isEmpty(nextProps.heath_and_safety) &&
      !nextState.hasSetMapProps
    ) {
      let selected_health_and_sanitization_entrypoint =
        nextProps.onboarding.selected_health_and_sanitization_entrypoint;
      let selected_health_and_sanitization_facility =
        nextProps.onboarding.selected_health_and_sanitization_facility;
      let selected_health_and_sanitization_employees =
        nextProps.onboarding.selected_health_and_sanitization_employees;
      let selected_health_and_sanitization_food_handling =
        nextProps.onboarding.selected_health_and_sanitization_food_handling;
      let selected_health_and_sanitization_health_safety =
        nextProps.onboarding.selected_health_and_sanitization_health_safety;
      let primary_health_and_sanitization_entrypoint =
        nextProps.onboarding.primary_health_and_sanitization_entrypoint;
      let primary_health_and_sanitization_facility =
        nextProps.onboarding.primary_health_and_sanitization_facility;
      let primary_health_and_sanitization_employees =
        nextProps.onboarding.primary_health_and_sanitization_employees;
      let primary_health_and_sanitization_food_handling =
        nextProps.onboarding.primary_health_and_sanitization_food_handling;
      let primary_health_and_sanitization_health_safety =
        nextProps.onboarding.primary_health_and_sanitization_health_safety;

      if (
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_entrypoint
        ) &&
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_facility
        ) &&
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_employees
        ) &&
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_food_handling
        ) &&
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_health_safety
        ) &&
        !isEmpty(selected_health_and_sanitization_entrypoint[0]) &&
        !isEmpty(selected_health_and_sanitization_facility[0]) &&
        !isEmpty(selected_health_and_sanitization_employees[0]) &&
        !isEmpty(selected_health_and_sanitization_food_handling[0]) &&
        !isEmpty(selected_health_and_sanitization_health_safety[0])
      ) {
        if (
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_entrypoint
          ) &&
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_facility
          ) &&
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_employees
          ) &&
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_food_handling
          ) &&
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_health_safety
          ) &&
          isEmpty(selected_health_and_sanitization_entrypoint[0]._id) &&
          isEmpty(selected_health_and_sanitization_facility[0]._id) &&
          isEmpty(selected_health_and_sanitization_employees[0]._id) &&
          isEmpty(selected_health_and_sanitization_food_handling[0]._id) &&
          isEmpty(selected_health_and_sanitization_health_safety[0]._id) &&
          selected_health_and_sanitization_entrypoint.length > 0 &&
          selected_health_and_sanitization_facility.length > 0 &&
          selected_health_and_sanitization_employees.length > 0 &&
          selected_health_and_sanitization_food_handling.length > 0 &&
          selected_health_and_sanitization_health_safety.length > 0 &&
          isEmpty(primary_health_and_sanitization_entrypoint._id) &&
          isEmpty(primary_health_and_sanitization_facility._id) &&
          isEmpty(primary_health_and_sanitization_employees._id) &&
          isEmpty(primary_health_and_sanitization_food_handling._id) &&
          isEmpty(primary_health_and_sanitization_health_safety._id)
        ) {
          selected_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter((data) =>
              selected_health_and_sanitization_entrypoint.includes(data._id)
            );
          selected_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter((data) =>
              selected_health_and_sanitization_facility.includes(data._id)
            );
          selected_health_and_sanitization_employees =
            nextProps.health_employees.filter((data) =>
              selected_health_and_sanitization_employees.includes(data._id)
            );
          selected_health_and_sanitization_food_handling =
            nextProps.health_handling.filter((data) =>
              selected_health_and_sanitization_food_handling.includes(data._id)
            );
          selected_health_and_sanitization_health_safety =
            nextProps.heath_and_safety.filter((data) =>
              selected_health_and_sanitization_health_safety.includes(data._id)
            );

          primary_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter(
              (data) => data._id === primary_health_and_sanitization_entrypoint
            )[0];
          primary_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter(
              (data) => data._id === primary_health_and_sanitization_facility
            )[0];
          primary_health_and_sanitization_employees =
            nextProps.health_employees.filter(
              (data) => data._id === primary_health_and_sanitization_employees
            )[0];
          primary_health_and_sanitization_food_handling =
            nextProps.health_handling.filter(
              (data) =>
                data._id === primary_health_and_sanitization_food_handling
            )[0];
          primary_health_and_sanitization_health_safety =
            nextProps.heath_and_safety.filter(
              (data) =>
                data._id === primary_health_and_sanitization_health_safety
            )[0];
        }
      }
      let all_healthandsanitization_entrypoint =
        nextProps.health_entry_point.filter(
          (point) =>
            !selected_health_and_sanitization_entrypoint.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_facility =
        nextProps.health_inside_facility.filter(
          (point) =>
            !selected_health_and_sanitization_facility.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_employees =
        nextProps.health_employees.filter(
          (point) =>
            !selected_health_and_sanitization_employees.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_food_handling =
        nextProps.health_handling.filter(
          (point) =>
            !selected_health_and_sanitization_food_handling.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_health_safety =
        nextProps.heath_and_safety.filter(
          (point) =>
            !selected_health_and_sanitization_health_safety.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let selectedPageLocal = 1;
      // !isEmpty(nextProps.onboarding.selectedPage)
      // ? nextProps?.onboarding?.selectedPage
      // : nextProps?.location?.state?.selectedPage
      // ? nextProps?.location?.state?.selectedPage
      // : 1,

      // Onboarding page set automatically if he comes to the based on UAT Issue traker issue no. 298
      if (
        !isEmpty(nextProps.onboarding.selectedPage) &&
        nextProps?.onboarding?.selectedPage
      ) {
        selectedPageLocal = nextProps?.onboarding?.selectedPage;
      }
      // else if (nextProps?.location?.state?.selectedPage) {
      //   selectedPageLocal = nextProps?.location?.state?.selectedPage;
      // }
      return {
        selected_health_and_sanitization_entrypoint: !isEmpty(
          selected_health_and_sanitization_entrypoint
        )
          ? selected_health_and_sanitization_entrypoint
          : [],
        selected_health_and_sanitization_facility: !isEmpty(
          selected_health_and_sanitization_facility
        )
          ? selected_health_and_sanitization_facility
          : [],
        selected_health_and_sanitization_employees: !isEmpty(
          selected_health_and_sanitization_employees
        )
          ? selected_health_and_sanitization_employees
          : [],
        selected_health_and_sanitization_food_handling: !isEmpty(
          selected_health_and_sanitization_food_handling
        )
          ? selected_health_and_sanitization_food_handling
          : [],
        selected_health_and_sanitization_health_safety: !isEmpty(
          selected_health_and_sanitization_health_safety
        )
          ? selected_health_and_sanitization_health_safety
          : [],
        primary_health_and_sanitization_entrypoint: !isEmpty(
          primary_health_and_sanitization_entrypoint
        )
          ? primary_health_and_sanitization_entrypoint
          : {},
        primary_health_and_sanitization_facility: !isEmpty(
          primary_health_and_sanitization_facility
        )
          ? primary_health_and_sanitization_facility
          : {},
        primary_health_and_sanitization_employees: !isEmpty(
          primary_health_and_sanitization_employees
        )
          ? primary_health_and_sanitization_employees
          : {},
        primary_health_and_sanitization_food_handling: !isEmpty(
          primary_health_and_sanitization_food_handling
        )
          ? primary_health_and_sanitization_food_handling
          : {},
        primary_health_and_sanitization_health_safety: !isEmpty(
          primary_health_and_sanitization_health_safety
        )
          ? primary_health_and_sanitization_health_safety
          : {},

        discription: nextProps.onboarding.discription,
        healthAndSanitizeSwitchValue:
          nextProps.onboarding.healthAndSanitizeSwitchValue &&
          (nextProps?.location?.state?.selectedPage === 0 ? false : true),
        healthAndSanitizeEntryPointCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeEntryPointCheck
        )
          ? nextProps.onboarding.healthAndSanitizeEntryPointCheck
          : true,
        healthAndSanitizeFacilityCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeFacilityCheck
        )
          ? nextProps.onboarding.healthAndSanitizeFacilityCheck
          : true,
        healthAndSanitizeServicesCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeServicesCheck
        )
          ? nextProps.onboarding.healthAndSanitizeServicesCheck
          : true,
        healthAndSanitizeEmployeesCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeEmployeesCheck
        )
          ? nextProps.onboarding.healthAndSanitizeEmployeesCheck
          : true,
        healthAndSanitizePracticesCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizePracticesCheck
        )
          ? nextProps.onboarding.healthAndSanitizePracticesCheck
          : true,
        healthAndSanitizeProtocolCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeProtocolCheck
        )
          ? nextProps.onboarding.healthAndSanitizeProtocolCheck
          : true,
        healthandsanitization_entrypoint: all_healthandsanitization_entrypoint,
        healthandsanitization_facility: all_healthandsanitization_facility,
        healthandsanitization_employees: all_healthandsanitization_employees,
        healthandsanitization_food_handling:
          all_healthandsanitization_food_handling,
        healthandsanitization_health_safety:
          all_healthandsanitization_health_safety,
        selectedPage: nextProps?.onboarding?.selectedPage || 1,
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
        selectedPage: nextProps?.onboarding?.selectedPage || 1,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
    let caps = e.target.value;
    caps = caps.charAt(0).toUpperCase() + caps.slice(1);
    let dataSet = caps;
    this.setState({
      [e.target.name]: dataSet,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  entryPointCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeEntryPointCheck:
        !this.state.healthAndSanitizeEntryPointCheck,
      actionButton: true,
    });
  };

  facilityCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeFacilityCheck:
        !this.state.healthAndSanitizeFacilityCheck,
      actionButton: true,
    });
  };

  servicesCheckSwitchValue = (e) => {
    console.log("hi1");
    this.setState({
      healthAndSanitizeServicesCheck:
        !this.state.healthAndSanitizeServicesCheck,
      actionButton: true,
    });
  };

  employeesCheckSwitchValue = (e) => {
    console.log("hi2");
    this.setState({
      healthAndSanitizeEmployeesCheck:
        !this.state.healthAndSanitizeEmployeesCheck,
      actionButton: true,
    });
  };

  practicesCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizePracticesCheck:
        !this.state.healthAndSanitizePracticesCheck,
      actionButton: true,
    });
  };

  protocolCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeProtocolCheck:
        !this.state.healthAndSanitizeProtocolCheck,
      actionButton: true,
    });
  };

  onClickHomeButton = (e) => {
    // let formData = {
    //   id: this.props.onboarding._id,
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   healthAndSanitizeSwitchValue: true,
    // };
    // this.props.create_and_update_restaurant(formData);
    this.setState({
      healthAndSanitizeSwitchValue: true,
    });
  };

  /********************************
   * @DESC Entery Point Handler
   ********************************/
  onEnteryPointBackButton = (e) => {
    // let formData = {
    //   selectedPage: 1,
    //   id: this.props.onboarding._id,
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   healthAndSanitizeSwitchValue: false,
    // };
    // this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
      healthAndSanitizeSwitchValue: false,
    });
    // this.props.history.push("/poswithid");
    // this.setState({
    //   healthAndSanitizeSwitchValue: false,
    //   actionButton: false,
    // });
  };
  whithOutEnteryPointNextButton = (e) => {
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  onEnteryPointNextButton = (e) => {
    let formData = {
      healthAndSanitizeEntryPointCheck:
        this.state.healthAndSanitizeEntryPointCheck,
      selected_health_and_sanitization_entrypoint:
        this.state.selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        this.state.primary_health_and_sanitization_entrypoint,
      selectedPage: 2,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };

  /********************************
   * @DESC Inside Facility Handler
   ********************************/
  onInsideFacilityBackButton = (e) => {
    this.setState({
      selectedPage: 1,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  whithOutInsideFacilityNextButton = (e) => {
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  onInsideFacilityNextButton = (e) => {
    let formData = {
      healthAndSanitizeFacilityCheck: this.state.healthAndSanitizeFacilityCheck,
      selected_health_and_sanitization_facility:
        this.state.selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility:
        this.state.primary_health_and_sanitization_facility,
      selectedPage: 3,
      id: this.props.onboarding._id,
    };
    console.log(formData);
    this.props.create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };

  /********************************
   * @DESC Employee Handler
   ********************************/
  onEmployeesBackButton = (e) => {
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  whithOutEmployeesNextButton = (e) => {
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  onEmployeesNextButton = (e) => {
    let formData = {
      healthAndSanitizeEmployeesCheck:
        this.state.healthAndSanitizeEmployeesCheck,

      selected_health_and_sanitization_employees:
        this.state.selected_health_and_sanitization_employees,
      primary_health_and_sanitization_employees:
        this.state.primary_health_and_sanitization_employees,
      selectedPage: 4,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };

  /********************************
   * @DESC Food Handling Handler
   ********************************/
  onFoodHandlingBackButton = (e) => {
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  whithOutFoodHandlingNextButton = (e) => {
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  onFoodHandlingNextButton = (e) => {
    let formData = {
      healthAndSanitizeServicesCheck: this.state.healthAndSanitizeServicesCheck,
      selected_health_and_sanitization_food_handling:
        this.state.selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        this.state.primary_health_and_sanitization_food_handling,
      selectedPage: 5,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };

  /********************************
   * @DESC Health Safety Handler
   ********************************/
  onHealthSafetyBackButton = (e) => {
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  whithOutHealthSafetyNextButton = (e) => {
    this.setState({
      selectedPage: 6,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  onHealthSafetyNextButton = (e) => {
    let formData = {
      healthAndSanitizePracticesCheck:
        this.state.healthAndSanitizePracticesCheck,
      selected_health_and_sanitization_health_safety:
        this.state.selected_health_and_sanitization_health_safety,
      primary_health_and_sanitization_health_safety:
        this.state.primary_health_and_sanitization_health_safety,
      selectedPage: 6,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 6,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };

  /****************************************
   * @DESC Discription Protocol Handler
   ***************************************/
  onDiscriptionProtocolBackButton = (e) => {
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push("/healthsenitation");
  };
  whithOutDiscriptionProtocolNextButton = (e) => {
    this.setState({
      actionButton: false,
    });
    this.props.history.push("/cuisinesetup");
  };

  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_health_and_sanitization;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization: restaurantTypeArray,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Others Health Seafty SELECTOR
   ****************************************/
  othersHealthAndSafetyHandler = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_entrypoint;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_entrypoint;
    let primaryIcon = this.state.primary_health_and_sanitization_entrypoint;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_entrypoint: Restaurant,
        primary_health_and_sanitization_entrypoint: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_entrypoint: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerTwo = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_facility;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_facility;
    let primaryIcon = this.state.primary_health_and_sanitization_facility;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_facility: Restaurant,
        primary_health_and_sanitization_facility: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_facility: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerThree = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_employees;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_employees;
    let primaryIcon = this.state.primary_health_and_sanitization_employees;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_employees: Restaurant,
        primary_health_and_sanitization_employees: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_employees: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerFour = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_food_handling;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_food_handling;
    let primaryIcon = this.state.primary_health_and_sanitization_food_handling;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_food_handling: Restaurant,
        primary_health_and_sanitization_food_handling: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_food_handling: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerFive = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_health_safety;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_health_safety;
    let primaryIcon = this.state.primary_health_and_sanitization_health_safety;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_health_safety: Restaurant,
        primary_health_and_sanitization_health_safety: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_health_safety: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_entrypoint: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorTwo = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_facility: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorThree = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_employees: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorFour = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_food_handling: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorFive = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_health_safety: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  othersHealthAndSafetyRemoveButton = (icon) => (e) => {
    let {
      healthandsanitization_entrypoint,
      selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_entrypoint.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_entrypoint.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_entrypoint) &&
      primary_health_and_sanitization_entrypoint._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_entrypoint.length === 0) {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_entrypoint = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      } else {
        primary_health_and_sanitization_entrypoint = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      }
    } else {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_entrypoint:
        selected_health_and_sanitization_entrypoint,
      healthandsanitization_entrypoint: healthandsanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        primary_health_and_sanitization_entrypoint,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonTwo = (icon) => (e) => {
    let {
      healthandsanitization_facility,
      selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_facility.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_facility.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_facility) &&
      primary_health_and_sanitization_facility._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_facility.length === 0) {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_facility = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      } else {
        primary_health_and_sanitization_facility = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      }
    } else {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_facility:
        selected_health_and_sanitization_facility,
      healthandsanitization_facility: healthandsanitization_facility,
      primary_health_and_sanitization_facility:
        primary_health_and_sanitization_facility,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonThree = (icon) => (e) => {
    let {
      healthandsanitization_employees,
      selected_health_and_sanitization_employees,
      primary_health_and_sanitization_employees,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_employees.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_employees.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_employees) &&
      primary_health_and_sanitization_employees._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_employees.length === 0) {
      selected_health_and_sanitization_employees.push(icon);
      healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_employees = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_employees.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_employees.push(icon);
      if (selected_health_and_sanitization_employees.length === 1) {
        primary_health_and_sanitization_employees =
          selected_health_and_sanitization_employees[0];
      } else {
        primary_health_and_sanitization_employees = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_employees.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_employees.push(icon);
      if (selected_health_and_sanitization_employees.length === 1) {
        primary_health_and_sanitization_employees =
          selected_health_and_sanitization_employees[0];
      }
    } else {
      selected_health_and_sanitization_employees.push(icon);
      healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_employees:
        selected_health_and_sanitization_employees,
      healthandsanitization_employees: healthandsanitization_employees,
      primary_health_and_sanitization_employees:
        primary_health_and_sanitization_employees,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonFour = (icon) => (e) => {
    let {
      healthandsanitization_food_handling,
      selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_food_handling.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_food_handling.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_food_handling) &&
      primary_health_and_sanitization_food_handling._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_food_handling.length === 0) {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_food_handling = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      } else {
        primary_health_and_sanitization_food_handling = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      }
    } else {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_food_handling:
        selected_health_and_sanitization_food_handling,
      healthandsanitization_food_handling: healthandsanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        primary_health_and_sanitization_food_handling,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonFive = (icon) => (e) => {
    let {
      healthandsanitization_health_safety,
      selected_health_and_sanitization_health_safety,
      primary_health_and_sanitization_health_safety,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_health_safety.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_health_safety.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_health_safety) &&
      primary_health_and_sanitization_health_safety._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_health_safety.length === 0) {
      selected_health_and_sanitization_health_safety.push(icon);
      healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_health_safety = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_health_safety.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_health_safety.push(icon);
      if (selected_health_and_sanitization_health_safety.length === 1) {
        primary_health_and_sanitization_health_safety =
          selected_health_and_sanitization_health_safety[0];
      } else {
        primary_health_and_sanitization_health_safety = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_health_safety.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_health_safety.push(icon);
      if (selected_health_and_sanitization_health_safety.length === 1) {
        primary_health_and_sanitization_health_safety =
          selected_health_and_sanitization_health_safety[0];
      }
    } else {
      selected_health_and_sanitization_health_safety.push(icon);
      healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_health_safety:
        selected_health_and_sanitization_health_safety,
      healthandsanitization_health_safety: healthandsanitization_health_safety,
      primary_health_and_sanitization_health_safety:
        primary_health_and_sanitization_health_safety,
      actionButton: true,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      //   this.props.onboarding.selected_health_and_sanitization_entrypoint) ||
      // (this.props.onboarding &&
      //   this.props.onboarding.selected_health_and_sanitization_facility) ||
      // (this.props.onboarding &&
      //   this.props.onboarding.selected_health_and_sanitization_employees) ||
      // (this.props.onboarding &&
      //   this.props.onboarding.selected_health_and_sanitization_food_handling) ||
      // (this.props.onboarding &&
      //   this.props.onboarding.selected_health_and_sanitization_health_safety) ||
      (this.props.onboarding && this.props.onboarding.discription) !== "" &&
      (this.props.onboarding && this.props.onboarding.discription) !==
        undefined &&
      (this.props.onboarding && this.props.onboarding.discription) !== null
    ) {
      const formData = {
        healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
        healthAndSanitizeProtocolCheck:
          this.state.healthAndSanitizeProtocolCheck,
        selectedPage: this.state.selectedPage,
        selected_health_and_sanitization_entrypoint:
          this.state.selected_health_and_sanitization_entrypoint,
        selected_health_and_sanitization_facility:
          this.state.selected_health_and_sanitization_facility,
        selected_health_and_sanitization_employees:
          this.state.selected_health_and_sanitization_employees,
        selected_health_and_sanitization_food_handling:
          this.state.selected_health_and_sanitization_food_handling,
        selected_health_and_sanitization_health_safety:
          this.state.selected_health_and_sanitization_health_safety,
        primary_health_and_sanitization_entrypoint:
          this.state.primary_health_and_sanitization_entrypoint,
        primary_health_and_sanitization_facility:
          this.state.primary_health_and_sanitization_facility,
        primary_health_and_sanitization_employees:
          this.state.primary_health_and_sanitization_employees,
        primary_health_and_sanitization_food_handling:
          this.state.primary_health_and_sanitization_food_handling,
        primary_health_and_sanitization_health_safety:
          this.state.primary_health_and_sanitization_health_safety,
        discription: this.state.discription,
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        selectedPage: 1,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/cuisinesetup");
    } else {
      const formData = {
        healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
        healthAndSanitizeProtocolCheck:
          this.state.healthAndSanitizeProtocolCheck,
        selectedPage: this.state.selectedPage,
        selected_health_and_sanitization_entrypoint:
          this.state.selected_health_and_sanitization_entrypoint,
        selected_health_and_sanitization_facility:
          this.state.selected_health_and_sanitization_facility,
        selected_health_and_sanitization_employees:
          this.state.selected_health_and_sanitization_employees,
        selected_health_and_sanitization_food_handling:
          this.state.selected_health_and_sanitization_food_handling,
        selected_health_and_sanitization_health_safety:
          this.state.selected_health_and_sanitization_health_safety,
        primary_health_and_sanitization_entrypoint:
          this.state.primary_health_and_sanitization_entrypoint,
        primary_health_and_sanitization_facility:
          this.state.primary_health_and_sanitization_facility,
        primary_health_and_sanitization_employees:
          this.state.primary_health_and_sanitization_employees,
        primary_health_and_sanitization_food_handling:
          this.state.primary_health_and_sanitization_food_handling,
        primary_health_and_sanitization_health_safety:
          this.state.primary_health_and_sanitization_health_safety,
        discription: this.state.discription,
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        page_completed_till: 16,
        selectedPage: 1,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/cuisinesetup");
    }

    // this.props.history.push({
    //   pathname: "/cuisinesetup",
    //   state: { data: formData },
    // });
  };

  renderHealthsenitationFields = () => {
    const {
      // healthAndSanitizeSwitchValue,
      errors,
      actionButton,
      healthAndSanitizeEntryPointCheck,
      healthAndSanitizeFacilityCheck,
      healthAndSanitizeServicesCheck,
      healthAndSanitizeEmployeesCheck,
      healthAndSanitizePracticesCheck,
      healthAndSanitizeProtocolCheck,
    } = this.state;
    // console.log(this.state);
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main">
              {this.state.selectedPage === 1 ? (
                <HealthAndSenitationOthers
                  bigText="What are the Hygiene and Sanitation options available at Entry Point?"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  entryPointCheck={healthAndSanitizeEntryPointCheck}
                  entryPointCheckHandler={this.entryPointCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_entrypoint}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_entrypoint
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_entrypoint
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandler
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelector
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButton}
                  onBackButtonClick={this.onEnteryPointBackButton}
                  onNextButtonClick={
                    // actionButton === false
                    //   ? this.whithOutEnteryPointNextButton
                    //   :
                    this.onEnteryPointNextButton
                  }
                />
              ) : null || this.state.selectedPage === 2 ? (
                <HealthAndSenitationOthersTwo
                  bigText="What are the Hygiene and Sanitation options available Inside the Facility"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  facilityCheck={healthAndSanitizeFacilityCheck}
                  facilityCheckHandler={this.facilityCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_facility}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_facility
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_facility
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerTwo
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorTwo
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonTwo}
                  onBackButtonTwoClick={this.onInsideFacilityBackButton}
                  onNextButtonTwoClick={
                    // actionButton === false
                    //   ? this.whithOutInsideFacilityNextButton
                    //   :
                    this.onInsideFacilityNextButton
                  }
                />
              ) : null || this.state.selectedPage === 3 ? (
                <HealthAndSenitationOthersThree
                  bigText="What are the Hygiene and Sanitation options available for food handling practices"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  employeesCheck={healthAndSanitizeEmployeesCheck}
                  employeesCheckHandler={this.employeesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_employees}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_employees
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_employees
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerThree
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorThree
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonThree}
                  onBackButtonThreeClick={this.onEmployeesBackButton}
                  onNextButtonThreeClick={
                    // actionButton === false
                    //   ? this.whithOutEmployeesNextButton
                    //   :
                    this.onEmployeesNextButton
                  }
                />
              ) : null || this.state.selectedPage === 4 ? (
                <HealthAndSenitationOthersFour
                  bigText="What are the Hygiene and Sanitation options available for Food Handling practices"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  servicesCheck={healthAndSanitizeServicesCheck}
                  servicesCheckHandler={this.servicesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_food_handling}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_food_handling
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_food_handling
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerFour
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorFour
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonFour}
                  onBackButtonFourClick={this.onFoodHandlingBackButton}
                  onNextButtonFourClick={
                    // actionButton === false
                    //   ? this.whithOutFoodHandlingNextButton
                    //   :
                    this.onFoodHandlingNextButton
                  }
                />
              ) : null || this.state.selectedPage === 5 ? (
                <HealthAndSenitationOthersFive
                  bigText="Following are other Health and Safety?"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  practiceCheck={healthAndSanitizePracticesCheck}
                  practiceCheckHandler={this.practicesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_health_safety}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_health_safety
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_health_safety
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerFive
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorFive
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonFive}
                  onBackButtonFiveClick={this.onHealthSafetyBackButton}
                  onNextButtonFiveClick={
                    actionButton === false
                      ? this.whithOutHealthSafetyNextButton
                      : this.onHealthSafetyNextButton
                  }
                />
              ) : null || this.state.selectedPage === 6 ? (
                <HealthAndSenitationProtocol
                  protocolCheck={healthAndSanitizeProtocolCheck}
                  protocolCheckHandler={this.protocolCheckSwitchValue}
                  onChange={this.onChange}
                  name="discription"
                  onFocusOut={this.onFocusOut}
                  discriptionProtocol={this.state.discription}
                  errors={
                    this.state.discription <= 0 ? errors.discription : null
                  }
                  onBackButtonClick={this.onDiscriptionProtocolBackButton}
                  // onClick={
                  //   actionButton === false
                  //     ? this.whithOutDiscriptionProtocolNextButton
                  //     : null
                  // }
                  // buttonType={actionButton === false ? "button" : "submit"}
                  buttonType="submit"
                />
              ) : null}
            </div>
          </div>
          {/* {healthAndSanitizeSwitchValue === false ? (
            <div className="onboarding-map-setup-screen-autodetect-button">
              <ReusableOnboardingLink
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                link="/poswithid"
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                buttonText="Next"
                buttonType="submit"
              />
            </div>
          ) : null} */}
        </div>
      </React.Fragment>
    );
  };
  handleFormShow = () => {
    this.setState({ formShow: true, healthAndSanitizeSwitchValue: false });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    const { formShow } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    selectedProgressBarOne="active"
                    selectedProgressBarTwo="active"
                    backLink={true}
                    onLink={"/poswithid"}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-05.svg")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f24_700_HelveticaNeue">
                    Health & Sanitization
                  </div>
                  {/* <div className="f16-400 opacity5">
                    Enter the details about your Business location
                  </div> */}
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link={"/poswithid"}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <Media query="(min-width: 992px)">
                <div className="col-12 onboarding_process_screen_left-backbutton">
                  {this.state.healthAndSanitizeSwitchValue === true ? (
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        workWithLinkORClick={true}
                        backButtonClicked={
                          this.state.selectedPage === 1
                            ? this.onEnteryPointBackButton
                            : this.state.selectedPage === 2
                            ? this.onInsideFacilityBackButton
                            : this.state.selectedPage === 3
                            ? this.onEmployeesBackButton
                            : this.state.selectedPage === 4
                            ? this.onFoodHandlingBackButton
                            : this.state.selectedPage === 5
                            ? this.onHealthSafetyBackButton
                            : this.state.selectedPage === 6
                            ? this.onDiscriptionProtocolBackButton
                            : null
                        }
                      />
                    </div>
                  ) : (
                    // </span>
                    // <NavLink to="/poswithid" className="back_button-link">
                    //   <Image
                    //     src={require("../../../../assets/images/Icon/onBoardBack.png")}
                    //     alt="Back Button"
                    //     title="Back Button"
                    //   />
                    // </NavLink>
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        backButtonClicked="/poswithid"
                      />
                    </div>
                  )}
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <>
                  {this.state.healthAndSanitizeSwitchValue === true ? (
                    <MobileTopHeader
                      onClick={
                        this.state.selectedPage === 1
                          ? this.onEnteryPointBackButton
                          : this.state.selectedPage === 2
                          ? this.onInsideFacilityBackButton
                          : this.state.selectedPage === 3
                          ? this.onEmployeesBackButton
                          : this.state.selectedPage === 4
                          ? this.onFoodHandlingBackButton
                          : this.state.selectedPage === 5
                          ? this.onHealthSafetyBackButton
                          : this.state.selectedPage === 6
                          ? this.onDiscriptionProtocolBackButton
                          : null
                      }
                    />
                  ) : (
                    <MobileTopHeader onClick={this.handleFormHide} />
                  )}
                </>
              </Media>
              {/* <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div> */}
              <div className="onboarding_process_screen-button-map">
                <div>
                  <TopTextReusableComponent
                    headingText="Health and Sanitation"
                    headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                  />
                </div>
                {this.state.healthAndSanitizeSwitchValue === true ? (
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                ) : (
                  <HealthAndSenitationHomeScreen
                    onClickHome={this.onClickHomeButton}
                    handleFormHide={this.handleFormHide}
                  />
                )}
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                selectedProgressBarTwo="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-05.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

HealthAndSenitationOnboardingComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  health_entry_point: state.category.health_entry_point,
  health_inside_facility: state.category.health_inside_facility,
  health_employees: state.category.health_employees,
  health_handling: state.category.health_handling,
  heath_and_safety: state.category.heath_and_safety,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(HealthAndSenitationOnboardingComponent));
